import { Fighter } from '../../domain/models/fighter.model';
import { Action } from '../action.type';

export const RETRIEVE_FIGHTERS = 'RETRIEVE_FIGHTERS';
export const RETRIEVE_FIGHTERS_SUCCESS = 'RETRIEVE_FIGHTERS_SUCCESS';
export const RETRIEVE_FIGHTERS_FAILURE = 'RETRIEVE_FIGHTERS_FAILURE';

export type RetrieveFightersPayload = {
  retry: number;
};

export interface RetrieveFighters extends Action<RetrieveFightersPayload> {
  type: typeof RETRIEVE_FIGHTERS;
  payload: RetrieveFightersPayload;
}

export interface RetrieveFightersSuccess extends Action<Fighter[]> {
  type: typeof RETRIEVE_FIGHTERS_SUCCESS;
  payload: Fighter[];
}

export interface RetrieveFightersFailure extends Action<string> {
  type: typeof RETRIEVE_FIGHTERS_FAILURE;
  payload: string;
}
